'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconOuterStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleIcons = require('reactackle-icons');

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  disabled: _propTypes2.default.bool,
  /**
   * Full-width TextField doesn't have borders
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * If textfield is dense it has smaller paddings
   */
  dense: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success'])
};

var defaultProps = {
  disabled: false,
  fullWidth: false,
  dense: false,
  colorScheme: 'neutral'
};

/** PROP RECEIVERS */
var iconBase = function iconBase(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var iconSpacing = theme.reactackle.components.textfield.iconOuter.iconSpacing;


  return '\n    padding-right: ' + (0, _reactackleCore.getValueString)(iconSpacing) + ';\n  ';
};

var iconStyle = function iconStyle(_ref2) {
  var themeFromProvider = _ref2.theme,
      disabled = _ref2.disabled,
      colorScheme = _ref2.colorScheme,
      focus = _ref2.focus;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.textfield.iconOuter.state;

  var source = null;
  if (!disabled) {
    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
  } else {
    source = path.disabled;
  }

  var _source = source,
      color = _source.color,
      opacity = _source.opacity;


  return (0, _styledComponents.css)(['opacity:', ';', ''], opacity, (0, _reactackleIcons.iconStyleMixin)(color));
};

var iconSize = function iconSize(_ref3) {
  var dense = _ref3.dense,
      fullWidth = _ref3.fullWidth,
      themeFromProvider = _ref3.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.textfield.iconOuter;

  var source = null;
  if (dense && !fullWidth) source = path.size.dense;else if (dense && fullWidth) source = path.size.denseFullWidth;else if (!dense && fullWidth) source = path.size.fullWidth;else source = path.size;

  var _source2 = source,
      boxSize = _source2.boxSize,
      imgSize = _source2.imgSize;


  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(boxSize), (0, _reactackleCore.getValueString)(imgSize || boxSize), (0, _reactackleCore.getValueString)(boxSize)));
};

/** STYLES */
var IconOuterStyled = exports.IconOuterStyled = _styledComponents2.default.label.withConfig({
  displayName: 'IconOuterStyled'
})(['display:flex;box-sizing:content-box !important;', ';', ';', ';', ';'], iconBase, iconSize, iconStyle, (0, _reactackleCore.transition)('color, opacity'));

IconOuterStyled.propTypes = propTypes;
IconOuterStyled.defaultProps = defaultProps;
IconOuterStyled.displayName = 'IconOuterStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text-field/dist/styles/IconOuterStyled.js
// module id = 839
// module chunks = 0